import { fontGroups } from '@zoopla-eng/zds-components/themes';
import { Agent, ListingsStatisticsData, Maybe } from '../graphql.generated';
import {
    ddStyle,
    definitionStyle,
    dlStyle,
    dtStyle,
    statsAreaStyle
} from './AgentStats.styles.css';

export const RESIDENTIAL_STATS_TITLE = 'Homes on Zoopla';
export const COMMERCIAL_STATS_TITLE = 'Commercial properties on Zoopla';
export const CURRENT_LABEL = {
    sale: 'Currently for sale',
    rent: 'Currently for rent'
} as const;
export const ASKING_PRICE_LABEL = 'Average asking price';
export const LISTING_TIME = 'Average listing time';
export const WEEKS_LABEL = 'weeks';
export const WEEK_LABEL = 'week';

export function AgentStats({
    listingsStatistics
}: {
    listingsStatistics: Agent['listingsStatistics'];
}) {
    if (!listingsStatistics) return null;

    const { residential, commercial } = listingsStatistics;
    return (
        <div className={statsAreaStyle}>
            {residential && (
                <>
                    <h3 className={fontGroups.ladle}>
                        {RESIDENTIAL_STATS_TITLE}
                    </h3>
                    <StatsBlock type="sale" statistics={residential.forSale} />
                    <StatsBlock type="rent" statistics={residential.toRent} />
                </>
            )}
            {commercial && (
                <>
                    <h3 className={fontGroups.ladle}>
                        {COMMERCIAL_STATS_TITLE}
                    </h3>
                    <StatsBlock type="sale" statistics={commercial.forSale} />
                    <StatsBlock type="rent" statistics={commercial.toRent} />
                </>
            )}
        </div>
    );
}

const formatGBPPrice = Intl.NumberFormat('en-gb', {
    style: 'currency',
    currency: 'GBP',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
}).format;

export const weeklyToPCMFormat = (n: number) =>
    `${formatGBPPrice((n * 52) / 12)} pcm`;

export function StatsBlock({
    type,
    statistics
}: {
    type: 'sale' | 'rent';
    statistics: Maybe<ListingsStatisticsData> | undefined;
}) {
    if (!statistics) return null;

    const formatter = type === 'rent' ? weeklyToPCMFormat : formatGBPPrice;
    return (
        <dl className={`${dlStyle} ${fontGroups.fork}`}>
            <div className={definitionStyle}>
                <dt className={dtStyle}>{CURRENT_LABEL[type]}</dt>
                <dd className={ddStyle}>{statistics.availableListings}</dd>
            </div>

            <div className={definitionStyle}>
                <dt className={dtStyle}>{ASKING_PRICE_LABEL}</dt>
                <dd className={ddStyle}>
                    {formatter(statistics.avgAskingPrice)}
                </dd>
            </div>

            <div className={definitionStyle}>
                <dt className={dtStyle}>{LISTING_TIME}</dt>
                <dd className={ddStyle}>
                    {typeof statistics.avgWeeksOnMarket === 'number'
                        ? `${statistics.avgWeeksOnMarket} ${
                              statistics.avgWeeksOnMarket > 1
                                  ? WEEKS_LABEL
                                  : WEEK_LABEL
                          }`
                        : '-'}
                </dd>
            </div>
        </dl>
    );
}
